module.exports = __webpack_public_path__ + "static/img/wap.438927a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/初中/wap.svg
// module id = QCQX
// module chunks = 16